import { IMMERSIVE_PARAM } from '#pplx/frontend/apps/ask/routing/immersive.js';
import { SafeSessionStorage } from '#pplx/frontend/browser-storage/sessionStorage.js';
export const ONBOARDING_SLUG = 'onboarding-neo';
export const ONBOARDING_PATH = `/computer/tasks/${ONBOARDING_SLUG}`;
export const ONBOARDING_URL = `${ONBOARDING_PATH}?${IMMERSIVE_PARAM}=true`;
export function getNeoOnboardingCheckoutTier(searchParams) {
    if (searchParams?.get('stripe_checkout') !== 'success') {
        return;
    }
    const tier = searchParams.get('subscription_tier');
    return tier === 'pro' || tier === 'max' ? tier : undefined;
}
export function resolveNeoOnboardingIntroTier({ searchParams, subscriptionTier, isEnterprise, }) {
    if (isEnterprise) {
        return;
    }
    const checkoutTier = getNeoOnboardingCheckoutTier(searchParams);
    if (checkoutTier) {
        return checkoutTier;
    }
    return subscriptionTier === 'pro' || subscriptionTier === 'max' ? subscriptionTier : undefined;
}
const NEO_ASK_COMPLETION_STORAGE_KEY = 'pplx.neoAskCompletion';
export function markNeoAskCompletion() {
    SafeSessionStorage.setItem(NEO_ASK_COMPLETION_STORAGE_KEY, 'true');
}
export function isNeoOnboardingPending() {
    const isPending = SafeSessionStorage.getItem(NEO_ASK_COMPLETION_STORAGE_KEY) === 'true';
    if (isPending) {
        SafeSessionStorage.removeItem(NEO_ASK_COMPLETION_STORAGE_KEY);
    }
    return isPending;
}
//# sourceMappingURL=onboarding.js.map